// extracted by mini-css-extract-plugin
export default {"name":"styles-module__name__src-labstep-web-components-Organization-Item-_c7hhp"};